import { APIRequest } from "./APIRequest";
import { API_BASE_URL } from "../../settings";

type Params = Record<string, any>;

/**
 * Make REST calls onto Model. e.g. user
 */

type ID = string | number;
type MethodType = "GET" | "POST" | "PUT" | "DELETE";
export class ModelRequest extends APIRequest {
    constructor(private path: string) {
        super();
    }

    url(method: MethodType, id: ID = "", params?: Params) {
        let path = this.path;
        if (path.indexOf("/") === -1) {
            path = `/${path}/`;
        }

        let endpoint = `${API_BASE_URL}${path}`;
        if (typeof id !== "undefined") {
            const i = typeof id === "number" ? id.toString() : id;

            if (i.length > 0) {
                endpoint += `${i}/`;
            }
        }

        if (typeof params !== "undefined" && Object.keys(params).length > 0) {
            if (method === "GET" && params.url) {
                endpoint += `?${params.url}`;
            }

            let re;
            for (let k in params) {
                re = new RegExp(`:${k}`, "g");
                endpoint = endpoint.replace(re, params[k]);
            }
        }

        return endpoint;
    }

    list<T>(params?: Params) {
        return this.get<T>(this.url("GET", "", params));
    }

    fetch<T>(id: ID, params?: Params) {
        return this.get<T>(this.url("GET", id, params));
    }

    create<T>(data: any, params?: Params) {
        return this.post<T>(this.url("POST", "", params), data);
    }

    save<T>(data: any, id: ID, params?: Params) {
        return this.put<T>(this.url("PUT", id, params), data);
    }

    destroy<T>(id: ID, params?: Params) {
        return this.delete<T>(this.url("DELETE", id, params));
    }

    upload<T>(data: any, params?: Params) {
        return this._upload<T>(this.url("PUT", "", params), data);
    }

    fileURL(name: string, params?: Params) {
        return this.url("GET", name, params);
    }
}
